import { sendFetch, POST_OPTIONS, GET_OPTIONS } from './base.service';

const BASE_PATH = '/roles';

export const findAllRoles = async () => {
    return await sendFetch(`${BASE_PATH}/all`, GET_OPTIONS);
}